import { Spin } from 'antd';

import './CreatePasswordLoading.css';

/**
 * Loading state molecule for CreatePasswordPage.
 *
 * Shown while the invitation is being registered on mount.
 *
 * @category Molecules
 */
export const CreatePasswordLoading = () => (
  <div className="auth-page-container">
    <div className="auth-container">
      <div className="create-password-loading">
        <Spin size="large" />
      </div>
    </div>
  </div>
);
